


































































































































































































import {FadeTransition} from 'vue2-transitions'
import Vue from 'vue';
import JetApplicationMark from '@/Jetstream/ApplicationMark.vue'
import JetBanner from '@/Jetstream/Banner.vue'
import JetDropdown from '@/Jetstream/Dropdown.vue'
import JetDropdownLink from '@/Jetstream/DropdownLink.vue'
import JetNavLink from '@/Jetstream/NavLink.vue'
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink.vue'
import Section from "@/Types/Section";
import {Component, Prop, Provide} from 'vue-property-decorator';
import EdelmanLogo from '@/Components/EdelmanLogo.vue';
import {Page, PageProps} from '@inertiajs/inertia';
import User from '@/Types/User';

interface AppLayoutProps extends PageProps {
    title?: string,
    isAdmin: boolean,
    isImpersonated?: boolean,
    user?: User
}

@Component({
    components: {
        EdelmanLogo,
        JetApplicationMark,
        JetBanner,
        JetDropdown,
        JetDropdownLink,
        JetNavLink,
        JetResponsiveNavLink,
        FadeTransition,
    },
    metaInfo() {
        // @ts-ignore
        const title = this.$page.props.title || null
        return {
            title
        };
    },
})
export default class AppLayout extends Vue {
    $page!: Page<AppLayoutProps>

    @Prop({type: Array, default: () => []}) sections?: Section[]
    @Prop({type: String, default: ''}) activeSectionName!: string

    @Provide() showingNavigationDropdown: boolean = false
    @Provide() animate: boolean = false

    get isAdmin(): boolean {
        return this.$page.props.isAdmin
    }

    logout() {
        this.$inertia.post(this.route('logout'));
    }

    mounted(){
        this.animate = true
    }
}
